import React from "react";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Divider from "@mui/joy/Divider";
import Sheet from "@mui/joy/Sheet";
import Input from "@mui/joy/Input";
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import {ServerSetting} from "../../models/serverSetting";

type DefaultProps = {
    setting: ServerSetting,
    isNew: boolean,
    open: boolean,
    setOpen: (e: boolean) => void,
    onConfirm: (setting: ServerSetting) => Promise<boolean>
}

const EditorDialog = (props: DefaultProps) => {
    const {setting, isNew, open, setOpen, onConfirm} = props;

    const [key, setKey] = React.useState(setting.key);
    const [value, setValue] = React.useState(setting.value);
    const [description, setDescription] = React.useState(setting.description);

    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <ModalDialog>
                <ModalClose/>
                <Typography id="filter-modal" level="h2">
                    {isNew ? 'Новая настройка' : 'Редактировать настройку'}
                </Typography>
                <Divider sx={{my: 2}}/>
                <Sheet sx={{display: 'flex', flexDirection: 'column', gap: 2, overflowY: 'auto', overflowX: 'hidden'}}>
                    <FormControl>
                        <FormLabel>Ключ</FormLabel>
                        <Input placeholder="ключ" value={key} disabled={!isNew}
                               onChange={(event) => setKey(event.target.value)}/>
                    </FormControl>
                    <FormControl>
                        <FormLabel>Значение</FormLabel>
                        <Input placeholder="значение" value={value}
                               onChange={(event) => setValue(event.target.value)}/>
                    </FormControl>
                    <FormControl>
                        <FormLabel>Описание</FormLabel>
                        <Input placeholder="описание" value={description}
                               onChange={(event) => setDescription(event.target.value)}/>
                    </FormControl>
                    <Button
                        onClick={() => setOpen(false)}
                        color="neutral"
                    >
                        Отмена
                    </Button>
                    <Button
                        onClick={async ()  => {
                            if(await onConfirm({
                                key: key,
                                value: value,
                                description: description,
                                updatedBy: setting.updatedBy,
                                created: setting.created,
                                updated: setting.updated
                            })) {
                                setOpen(false);
                            }
                        }}
                        color="primary"
                    >
                        Сохранить
                    </Button>
                </Sheet>
            </ModalDialog>
        </Modal>
    );
};

export default EditorDialog;